// extracted by mini-css-extract-plugin
module.exports = {"kebabButton":"KebabButton__kebabButton__Yzcy6"};